import csv from './CsvMiddleware';
import contracts from './ContractMiddleware';
import customers from './CustomerMiddleware';
import auth from './AuthMiddleware';
import representatives from './RepresentativeMiddleware';
import contractEvents from './ContractEventsMiddleware';
import policies from './PoliciesMiddleware';

export default [
    csv,
    customers,
    contracts,
    auth,
    representatives,
    contractEvents,
    policies
];
